/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1746
 */

require(/* 578 */"./1750/578/index")("Int32", function (e) {
  return function (t, n, r) {
    return e(this, t, n, r)
  }
})
